import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface MarketingTabsConfig {
  budgeting: boolean;
  ai_content_creation: boolean;
  ai_sentiment_analysis: boolean;
  place: boolean;
}

export const useMarketingTabs = () => {
  const [config, setConfig] = useState<MarketingTabsConfig>({
    budgeting: true,
    ai_content_creation: true,
    ai_sentiment_analysis: true,
    place: true
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMarketingTabs = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('marketing_tabs')
          .select('budgeting, ai_content_creation, ai_sentiment_analysis, place')
          .limit(1)
          .single();

        if (fetchError) {
          console.error('Error fetching marketing tabs:', fetchError);
          setError('Failed to fetch marketing tabs configuration');
          return;
        }

        if (data) {
          setConfig({
            budgeting: data.budgeting || false,
            ai_content_creation: data.ai_content_creation || false,
            ai_sentiment_analysis: data.ai_sentiment_analysis || false,
            place: data.place || false
          });
        }
      } catch (error) {
        console.error('Error in fetchMarketingTabs:', error);
        setError('Failed to fetch marketing tabs configuration');
      } finally {
        setIsLoading(false);
      }
    };

    fetchMarketingTabs();
  }, []);

  return { config, isLoading, error };
};